import React from 'react';

const ActivityDetailPane = ({ activity }) => {
  if (!activity) {
    return (
      <div className="bg-gradient-to-br from-amber-50/90 to-orange-50/90 backdrop-blur-sm border border-amber-200/60 rounded-2xl p-6 shadow-lg">
        <div className="">
          <div className="h-8 bg-amber-200 rounded-lg mb-4"></div>
          <div className="h-4 bg-amber-200 rounded mb-2"></div>
          <div className="h-4 bg-amber-200 rounded mb-2"></div>
          <div className="h-4 bg-amber-200 rounded w-3/4"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-amber-50/90 to-orange-50/90 backdrop-blur-sm border border-amber-200/60 rounded-2xl p-6 shadow-lg">
      {/* Activity Cover Image */}
      {activity.coverImageUrl && (
        <div className="mb-6">
          <img
            src={activity.coverImageUrl}
            alt={activity.title}
            className="w-full h-48 object-cover rounded-xl shadow-md"
          />
        </div>
      )}

      {/* Activity Title */}
      <h1 className="text-3xl font-bold text-amber-800 mb-4 text-center">
        {activity.title}
      </h1>

      {/* Activity Description */}
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-amber-700 mb-3">About This Activity</h2>
        <p className="text-amber-800 leading-relaxed">
          {activity.description}
        </p>
      </div>

      {/* Activity Details */}
      <div className="space-y-4">
        {/* Prerequisites */}
        {Array.isArray(activity.prerequisites) && activity.prerequisites.length > 0 && (
          <div>
            <h3 className="text-lg font-semibold text-amber-700 mb-2">What You'll Need</h3>
            <ul className="space-y-1">
              {activity.prerequisites.map((item, index) => (
                <li key={index} className="flex items-start text-amber-800">
                  <span className="text-amber-500 mr-2 mt-1">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Steps */}
        {Array.isArray(activity.steps) && activity.steps.length > 0 && (
          <div>
            <h3 className="text-lg font-semibold text-amber-700 mb-2">Steps</h3>
            <ol className="space-y-2">
              {activity.steps.map((step, index) => (
                <li key={index} className="flex items-start text-amber-800">
                  <span className="bg-amber-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-semibold mr-3 mt-0.5 flex-shrink-0">
                    {index + 1}
                  </span>
                  <span>{step}</span>
                </li>
              ))}
            </ol>
          </div>
        )}

        {/* Tips */}
        {Array.isArray(activity.tips) && activity.tips.length > 0 && (
          <div>
            <h3 className="text-lg font-semibold text-amber-700 mb-2">💡 Tips</h3>
            <ul className="space-y-1">
              {activity.tips.map((tip, index) => (
                <li key={index} className="flex items-start text-amber-800">
                  <span className="text-amber-500 mr-2 mt-1">✨</span>
                  <span>{tip}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* Activity Metadata */}
      <div className="mt-6 pt-4 border-t border-amber-200/60">
        <div className="flex justify-between items-center text-sm text-amber-600">
          <span>Created: {activity.createdAt?.toDate?.()?.toLocaleDateString() || 'Recently'}</span>
          <span className="bg-amber-100 px-3 py-1 rounded-full text-amber-700 font-medium">
            Daily Activity
          </span>
        </div>
      </div>
    </div>
  );
};

export default ActivityDetailPane;
